import { useState, useRef } from "react";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import styles from "./UploadConsent.module.css";
import { toast } from "react-toastify";
import { uploadConsent } from "../../../../Services/BuySell/Listing";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchActiveConnection,
  fetchMainScreenActiveConnection,
} from "../../../../Redux/Slices/CapacitySlice";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { useLocation } from "react-router-dom";
import { useDroppable } from "@dnd-kit/react";
import { DndContext } from "@dnd-kit/core";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal";

const UploadConsent = ({
  open,
  onClose,
  connectionId,
  mode,
  capacityId,
  useSecondaryAccent = false,
}) => {
  const id = useSelector((state) => state.CapacitySlice?.activeMain?.id);

  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  let capId = capacityId || location?.search?.split("=")[1] || id;
  const inputRef = useRef();

  // DnD Kit droppable setup
  const { setNodeRef, isOver } = useDroppable({
    id: "dropzone",
  });

  const handleFileChange = (e) => {
    if (e.target.files[0].type !== "application/pdf") {
      toast.error("Only PDF files are allowed!");
      return;
    }
    setSelectedFile(e.target.files[0]);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) setSelectedFile(file);
  };

  const handleClick = () => {
    inputRef.current.click();
  };

  const handleViewDoc = async (id) => {
    try {
      if (selectedFile) {
        setPreviewFileUrl(URL.createObjectURL(selectedFile));
        setPreviewModal(true);
      } else {
        toast.error("Document URL not found");
      }
    } catch (err) {
      toast.error("Could not fetch document URL.");
    }
  };

  async function handleSubmit() {
    try {
      if (!selectedFile) {
        toast.error("Please select a file.");
        return;
      }
      if (selectedFile.type !== "application/pdf") {
        toast.error("Only PDF files are allowed!");
        return;
      }
      setLoading(true);
      const formData = new FormData();
      formData.append("file", selectedFile);
      await uploadConsent(formData, connectionId);
      toast.success("STOA uploaded successfully!");
      dispatch(fetchActiveConnection({ curr: 0, capId: capId }));
      dispatch(fetchMainScreenActiveConnection({ capId: capId }));
      onClose();
    } catch (error) {
      toast.error("Failed to upload STOA.");
    } finally {
      setLoading(false);
    }
  }

  const handleClosePreview = () => {
    setPreviewModal(false);
    setPreviewFileUrl(null);
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <div
          className={`${styles.modal} ${
            useSecondaryAccent ? "secondaryAccent" : ""
          }`}
        >
          <div className={styles.header}>
            <span className={styles.title}>Upload Consent</span>
            <button className={styles.close} onClick={onClose}>
              <Close fontSize="medium" />
            </button>
          </div>

          <div style={{ background: "#f1f1f1ff", padding: "20px" }}>
            <DndContext>
              <div
                ref={setNodeRef}
                className={`${styles.tableWrapper} ${
                  isOver ? styles.dragOver : ""
                }`}
                onClick={handleClick}
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "12px",
                  background: "#fafbfc",
                  padding: "32px",
                  textAlign: "center",
                  cursor: "pointer",
                }}
              >
                <input
                  type="file"
                  accept=".pdf"
                  onChange={handleFileChange}
                  ref={inputRef}
                  style={{ display: "none" }}
                />
                <div
                  style={{
                    fontSize: "32px",
                    color: "#bdbdbd",
                    marginBottom: "8px",
                  }}
                >
                  +
                </div>
                <div style={{ fontSize: "16px", color: "#666" }}>
                  Drag and drop, or click to{" "}
                  <span style={{ color: "var(--primary-color-text)" }}>
                    Upload
                  </span>
                  <br />
                  STOA Consent
                </div>
                {selectedFile && (
                  <div
                    className={styles.fileName}
                    style={{
                      marginTop: "16px",
                      color: "#333",
                    }}
                  >
                    Selected file: {selectedFile.name}{" "}
                    <div
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewDoc();
                      }}
                      aria-label={`View document }`}
                    >
                      <ViewIcon />
                    </div>
                  </div>
                )}
              </div>
            </DndContext>
          </div>
          {mode !== "view" && (
            <div className={styles.footer}>
              <button onClick={onClose} className={styles.reject}>
                Cancel
              </button>
              <button
                className={styles.approve}
                onClick={handleSubmit}
                disabled={!selectedFile}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          )}

          <PreviewModal
            open={previewModal}
            onClose={handleClosePreview}
            fileUrl={previewFileUrl}
          />
        </div>
      </Modal>
    </>
  );
};

export default UploadConsent;
